import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard

import DashboardCrypto from "../pages/DashboardCrypto";
import Home from "../pages/Home";
import WorkflowsLauncher from "../pages/WorkflowsLauncher";

//Accounting //Eng. //HR //IT // Planning // Production // Quality // Sales // Shipping //Shukla Medical // Supervisor // KPIs //DI //MAFIA //DisplayBoards

import Accounting from "../pages/Accounting/index";
import Perflexion from "../pages/Perflexion";
import Engineering from "../pages/Engineering/index";
import HumanResource from "../pages/HumanResource/index";
import InfoTechnology from "../pages/IT/index";
import Planning from "../pages/Planning/index";
import Production from "../pages/Production/index";
import Quality from "../pages/Quality/index";
import Sales from "../pages/Sales/index";
import Shipping from "../pages/Shipping/index";
import Shukla from "../pages/Shukla/index";
import Supervisor from "../pages/Supervisor/index";
import KPI from "../pages/KPI/index";
import XRayReport from "../pages/KPI/XRayReport";
import XRayRouteGuard from "../pages/KPI/XRayRouteGuard";
import KpiHubRouteGuard from "../pages/KPI/KpiHubRouteGuard";
import OtdReport from "../pages/KPI/OtdReport";
import PlanningRouteGuard from "../pages/KPI/PlanningRouteGuard";
import UnifiedReviewPage from "../pages/HumanResource/UnifiedReviewPage.js";

import ManageDepartments from "../pages/HumanResource/ManageDepartments.js";
import ManageRoles from "../pages/HumanResource/ManageRoles.js";
import HrDashboard from "../pages/HumanResource/HrDashboard.js";       // Phase 3 / Feature 2
import IndiaEmployees from "../pages/HumanResource/IndiaEmployees.js"; // Go-live parity (2026-09-24): India accounts
import MyProfile from "../pages/Profile/MyProfile.js";                  // Phase 3 / Feature 3
import SetupCode from "../pages/Authentication/SetupCode";              // Round 17
// ── Round: HR UI Simplification (Phase 1) ────────────────────────────────
// The deep HR pages (EmpReactivate, ProfileUpdateApprovals, AuditTrail,
// FtoYearEnd, AddPaidFto, FtoHrSummary, CompensationDays, FtoHolidays,
// YearEndRequestView, HrReviewDashboard, CoaCentral, LateInReview,
// AttendanceReport, LateInReport, AttendanceAnalytics, PayrollTimeCard,
// AddFtoHr, LeaveArchive, RecordAbsence) are no longer imported HERE:
// their old routes below now redirect into the canonical HR shell
// (/humanresource?section=…), which lazy-loads the SAME components via
// React.lazy (see src/pages/HumanResource/shell/*). Each redirect keeps
// its original RoleProtected wrapper at the old URL, so direct
// unauthorized hits are denied exactly as before. /hr/dashboard,
// /hr/departments, /hr/roles and /attendance/approvals are unchanged.
import DocumentManagementSystem from "../pages/DocumentManagementSystem/Index.js";
import ApprovalPage from "../pages/DocumentManagementSystem/ECN/ApprovalPage.js";
import AllDocuments from "../pages/DocumentManagementSystem/AllDocuments.js";
import Data from "../pages/DocumentManagementSystem/Data.js";
import CreateEcn from "../pages/DocumentManagementSystem/ECN/CreateEcn.js";

import AttendanceIndex from "../pages/Personal Attendance/index.js";
import FtoRequestPage from "../pages/Personal Attendance/FtoRequestPage.js";
// 2026-09: one Approvals screen (My team + HR) replaces the old FTO/COA workbench.
import HrReviewDashboard from "../pages/HumanResource/HrReviewDashboard";

import DI from "../pages/DI/index";
// Batch 3 / Round 15 — DI Simulator (legacy Simselect.vb, the "-j"
// engineer mode): read-only MAFIA-table preview, open to all employees
// per the audit decision (same app.di gate as /di).
import DISimulator from "../pages/DI/Inspection/SimSelect";
import DIAuditLog from "../pages/DI/AuditLog";

// IT Admin
import EmployeeRoleAssignment from "../pages/Admin/EmployeeRoleAssignment";
import EmployeeEpoLimitAssignment from "../pages/Admin/EmployeeEpoLimitAssignment";
import UserPermissionsPage from "../pages/Admin/UserPermissionsPage";
import AdminHub from "../pages/Admin/AdminHub";
import AccessManagement from "../pages/Admin/AccessManagement";
import AccessDenied from "../pages/AccessDenied";
import RoleProtected from "../Components/Common/RoleProtected";

// Phase 2.3b — DMS inbox pages
import MyTraining from "../pages/DocumentManagementSystem/Inbox/MyTraining";
// Round R1 — Restore dedicated DMS inbox pages (legacy menu parity:
//   "Documents Ready for Release" → DMSAwaiting releaser mode
//   "Documents Awaiting my Approval" → DMSAwaiting default mode)
import AwaitingRelease from "../pages/DocumentManagementSystem/Inbox/AwaitingRelease";
import MyPendingApprovals from "../pages/DocumentManagementSystem/Inbox/MyPendingApprovals";
// Round R12 (2026) — Save Draft (Q11) + email-link landing page.
import MyDrafts from "../pages/DocumentManagementSystem/Inbox/MyDrafts";
import TokenAction from "../pages/DocumentManagementSystem/Approval/TokenAction";



import Mafia from "../pages/Mafia/MenuPage.js";
import DisplayBoards from "../pages/DisplayBoards/index";
import EPO from "../pages/ExpensePurchaseOrder/index";
import EpoApprovalsTimeLine from "../pages/ExpensePurchaseOrder/EpoApprovalTimeline.js";

// Phase 3 Pass 2 — manager-menu EPO screens (per legacy menus):
//   "MPC EPO Viewer"               → /epo/mpc-viewer        role-based
//   "EPOs Not Ready For Payment"   → /epo/not-ready         every user
//   "Find EPO by Number"           → /epo/find              manager+
import MpcEpoViewer from "../pages/ExpensePurchaseOrder/MpcEpoViewer.js";
import EposNotReadyForPayment from "../pages/ExpensePurchaseOrder/EposNotReadyForPayment.js";
import FindEpoByNumber from "../pages/ExpensePurchaseOrder/FindEpoByNumber.js";
import SubordinateEpos from "../pages/ExpensePurchaseOrder/SubordinateEpos.js";
import EposReadyForPayment from "../pages/ExpensePurchaseOrder/EposReadyForPayment.js";
import EposShipping from "../pages/ExpensePurchaseOrder/EposShipping.js";
import EposReceive from "../pages/ExpensePurchaseOrder/EposReceive.js";  // R16
// Batch 3 / Round 7 — line-item search (Shipping/Find aid).
import EpoLineSearch from "../pages/ExpensePurchaseOrder/EpoLineSearch.js";
// Batch 3 / Round 8 — No-EPO / Missing-EPO shipment tracker.
import MissingEpoDashboard from "../pages/ExpensePurchaseOrder/MissingEpoDashboard.js";
import EpoPartialPayments from "../pages/ExpensePurchaseOrder/EpoPartialPayments.js";  // R19
import EpoApprovalsInbox from "../pages/ExpensePurchaseOrder/EpoApprovalsInbox.js";

// Phase 3 Pass 2 — manager-menu Project Approval screens:
//   "View My Department's Projects"  → /projects/my-department
//   "View Projects Awaiting Approval"→ /projects/awaiting-approval
import DeptProjects from "../pages/ProjectApproval/DeptProjects.js";
import ProjectsAwaitingApproval from "../pages/ProjectApproval/AwaitingApproval.js";

// Phase 3 Pass 3 — manager-menu FTO/COA, Tasks, Travel Expense.
//   /attendance/dept/fto[?future=1]   "Show All / Future FTOs of my Dept"
//   /attendance/dept/coa[?future=1]   "Show All / Future COAs of my Dept"
//   /attendance/ytd                   "Review YTD FTO Status"
//   /attendance/fto/schedule          "Show My FTO Schedule"
//   /attendance/coa/schedule          "Show My COA Schedule"
//   /task-management/dept             "View My Department's Tasks"
//   /task-management/by-date          "View My Task Reporting By Date"
//   /task-management/assigned         "View Tasks I've Assigned"
//   /travel-expense                   "Travel Expense Approval"
//   /travel-expense/:id               Trip detail + approve/reject
import DeptFtos            from "../pages/Personal Attendance/DeptFtos.js";
import DeptCoas            from "../pages/Personal Attendance/DeptCoas.js";
import YtdFtoReport        from "../pages/Personal Attendance/YtdFtoReport.js";
import MyFtoBalance        from "../pages/Personal Attendance/MyFtoBalance.js";  // G-37 (P8)
import { FtoSchedule, CoaSchedule } from "../pages/Personal Attendance/MyAttendanceSchedule.js";
import DeptTasks from "../pages/TaskManagement/DeptTasks.js";
import TaskReportingByDate from "../pages/TaskManagement/TaskReportingByDate.js";
import TasksIveAssigned from "../pages/TaskManagement/TasksIveAssigned.js";
// Rounds TM-7/9/13 (2026) — legacy screens restored.
import EndOfDay from "../pages/TaskManagement/EndOfDay.js";
import CurrentDeptActivity from "../pages/TaskManagement/CurrentDeptActivity.js";
import TaskAuditor from "../pages/TaskManagement/TaskAuditor.js";
import TravelExpenseIndex from "../pages/TravelExpense/index.js";
import TravelExpenseDetail from "../pages/TravelExpense/TravelExpenseDetail.js";
import TravelExpenseForm from "../pages/TravelExpense/TravelExpenseForm.js";
// Go-live parity (2026-09-24): travel back-office queues (audit 09-travel #4, #22/#23).
import { TravelHrQueue, TravelAccountingQueue } from "../pages/TravelExpense/TravelBackOfficeQueue.js";

import OrgChart from "../pages/OrganizationalChart/orgChart.js";
import TaskManagement from "../pages/TaskManagement/index.js";
import CreateTask from "../pages/TaskManagement/CreateTask/index.js";
import TaskDetail from "../pages/TaskManagement/TaskDetails/index.js";

// ── Merged from development branch ─────────────────────────────────────────
// Time & Attendance employee tools: PunchRecord (legacy punch history),
// WhosInBuilding (live presence), and a unified SchedulePage (FTO+COA combined
// month grid). Visitors page is the modern equivalent of the legacy
// Expected Visitors register.
import PunchRecord from "../pages/DashboardCrypto/PunchRecord.js";
import WhosInBuilding from "../pages/DashboardCrypto/WhosInBuilding.js";
import SchedulePage from "../pages/Personal Attendance/SchedulePage.js";
import ExpectedVisitors from "../pages/Visitors/index.js";
// Support module (Freshdesk) — read-write support tickets for SSW + Shukla.
import Support from "../pages/Support/index.js";

// ── Added during merge reconciliation ──────────────────────────────────────
// SN-PO Awaiting FL Approval — was deferred in earlier passes but the user
// asked for full legacy parity. Backend: Controllers/EPO/SnEpoController.cs.
import SnEpoAwaitingFlApproval from "../pages/ExpensePurchaseOrder/SnEpoAwaitingFlApproval.js";

// Contract Review (Pass 3 + Pass 4)
import ContractReview from "../pages/ContractReview/index";
import ContractReviewForm from "../pages/ContractReview/ContractReviewForm";

//Accounting //Eng. //HR //IT // Planning // Production // Quality // Sales // Shipping //Shukla Medical // Supervisor // KPIs //DI //MAFIA //DisplayBoards

//Calendar
// Email box

//Chat
// Project

//Task
import TaskDetails from "../pages/Tasks/TaskDetails";

//Transactions
//Crm Pages

//Invoices

// Support Tickets
// //Ecommerce Pages
// NFT Marketplace Pages
// Base Ui

// Advance Ui

// Widgets
//Forms

//Tables

//Icon pages

//Maps

//AuthenticationInner pages
//pages


import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";

//APi Key

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
// Access-Management hardening (Round 1, audit H-11): the public /register
// route (unauthenticated Add-Employee form) and the mock /loginAdmin page are
// removed. The Add-Employee form is still available INSIDE the HR area
// (pages/HumanResource/shell/HrEmployeesSection.js lazy-loads Register).

//Charts

//Job pages
// Landing Index


// User Profile
// HR Round 5 / Issue 8: user-profile.js (template stub) no longer routed —
// /profile now redirects to the canonical /profile/me self-service page.

import IT from "../pages/IT";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Home /> },
  // Round 16: workflows launcher (cards drill-down — see WorkflowsLauncher)
  { path: "/workflows", component: <WorkflowsLauncher /> },
  { path: "/time-and-attendance", component: (
      <RoleProtected requireModule="time.open">
        <DashboardCrypto />
      </RoleProtected>
    ) },


  // ── Department dashboards — gated to match the menu visibility ────────────
  // Direct URL access by an unauthorized user redirects to /access-denied.
  // Frontend menu also hides these. Backend controllers are also gated.
    // Perflexion (owner request, 2026-07): engineering part-formula tool —
  // coming-soon page for now, same pattern as Accounting. Open to all
  // authenticated users (informational page, no data).
  // Round 2 (decision D8): Apps are open to every active employee — the
  // app.* keys resolve true for any account that can log in.
  { path: "/perflexion", component: (<RoleProtected requireModule="app.perflexion"><Perflexion /></RoleProtected>) },
    {
    path: "/accounting",
    component: (
      <RoleProtected requireModule="dept.accounting">
        <Accounting />
      </RoleProtected>
    ),
  },
    {
    path: "/engineering",
    component: (
      <RoleProtected requireModule="dept.engineering">
        <Engineering />
      </RoleProtected>
    ),
  },
  {
    path: "/humanresource",
    component: (
      <RoleProtected requireHr>
        <HumanResource />
      </RoleProtected>
    ),
  },
    {
    path: "/planning",
    component: (
      <RoleProtected requireModule="dept.planning">
        <Planning />
      </RoleProtected>
    ),
  },
    {
    path: "/production",
    component: (
      <RoleProtected requireModule="dept.production">
        <Production />
      </RoleProtected>
    ),
  },
  {
    path: "/it",
    component: (
      <RoleProtected requireModule="dept.it">
        <InfoTechnology />
      </RoleProtected>
    ),
  },
    {
    path: "/quality",
    component: (
      <RoleProtected requireModule="dept.quality">
        <Quality />
      </RoleProtected>
    ),
  },
    {
    path: "/shukla",
    component: (
      <RoleProtected requireModule="dept.shukla">
        <Shukla />
      </RoleProtected>
    ),
  },
    {
    path: "/shipping",
    component: (
      <RoleProtected requireModule="dept.shipping">
        <Shipping />
      </RoleProtected>
    ),
  },
    {
    path: "/sales",
    component: (
      <RoleProtected requireModule="dept.sales">
        <Sales />
      </RoleProtected>
    ),
  },
  {
    path: "/supervisor",
    component: (
      <RoleProtected requireModule="dept.supervisor">
        <Supervisor />
      </RoleProtected>
    ),
  },
  {
    path: "/kpi",
    component: (
      <KpiHubRouteGuard>
        <KPI />
      </KpiHubRouteGuard>
    ),
  },
  {
    // Round 3: X-Ray finance report. Round 6: gate honors finance role OR a
    // granted KPI finance permission (mirrors backend CanAccessFinanceReports).
    path: "/kpi/xray",
    component: (
      <XRayRouteGuard>
        <XRayReport />
      </XRayRouteGuard>
    ),
  },
  {
    // Round 11: On-Time Delivery reports (Planning). One route serves both
    // summary-otd and blown-up via the :reportKey param.
    path: "/kpi/otd/:reportKey",
    component: (
      <PlanningRouteGuard>
        <OtdReport />
      </PlanningRouteGuard>
    ),
  },
  // HR/IT admin subpages — IT Admin only (these manage the system itself).
  {
    path: "/hr/departments",
    component: (
      <RoleProtected requireModule="admin.departments">
        <ManageDepartments />
      </RoleProtected>
    ),
  },
  {
    path: "/hr/roles",
    component: (
      <RoleProtected requireModule="admin.manageRoles">
        <ManageRoles />
      </RoleProtected>
    ),
  },

  // ── IT Admin ────────────────────────────────────────────────────────────
  // Backend also enforces [Authorize(Roles = "IT Admin")] on /api/admin/*,
  // so even bypassing this guard yields 403 from the API.

  // Round 20 (2026): /admin landing — shows the three admin tools as
  // cards. Sidebar's "IT Admin → Admin" link points here.
  {
    path: "/admin",
    component: (
      <RoleProtected requireModule="admin.hub">
        <AdminHub />
      </RoleProtected>
    ),
  },
  // Batch A (Rounds 3 & 4, 2026): consolidated Access Management page —
  // Roles + Role Permissions tabs (Employee Role Assignment, Direct User
  // Permissions, and Effective Access Preview tabs arrive in Batch B). The
  // existing standalone admin pages remain available and untouched. Backend
  // endpoints under /api/Role and /api/admin/access/* are also
  // [Authorize(Roles = "IT Admin")], so bypassing this guard still yields 403.
  {
    path: "/admin/access",
    // Round 12: any Access-Management tab (incl. Account Security) may open the page;
    // each tab is gated individually inside it.
    component: (
      <RoleProtected requireModule="admin.accessAny">
        <AccessManagement />
      </RoleProtected>
    ),
  },
  {
    path: "/admin/employee-roles",
    component: (
      <RoleProtected requireModule="admin.employeeRoles">
        <EmployeeRoleAssignment />
      </RoleProtected>
    ),
  },
  // Phase 1.6: per-user EPO approval limit assignment. Same IT Admin gate
  // as employee-roles above; the backend endpoints under /api/admin/employees-with-epo-limits
  // are also [Authorize(Roles = "IT Admin")] so bypassing the FE guard
  // still yields 403.
  {
    path: "/admin/employee-epo-limits",
    component: (
      <RoleProtected requireModule="admin.epoLimits">
        <EmployeeEpoLimitAssignment />
      </RoleProtected>
    ),
  },
  // Round 19 (2026): per-user permission grants (granular IT-Admin tool).
  // Backend endpoints under /api/admin/user-permissions/* are also
  // [Authorize(Roles = "IT Admin")] so bypassing this guard still yields 403.
  {
    path: "/admin/user-permissions",
    component: (
      <RoleProtected requireModule="admin.userPermissions">
        <UserPermissionsPage />
      </RoleProtected>
    ),
  },

  // Phase 2.3b — DMS inbox pages. My Training is genuinely separate from
  // the document list (it's training acknowledgements, not a doc status
  // filter).
  //
  // Round R1 (2026) — restored the two dedicated inbox pages that legacy
  // had as separate menu items under "Document Management System":
  //   • "Documents Awaiting my Approval"  → /dms/my-pending-approvals
  //   • "Documents Ready for Release"     → /dms/awaiting-release (gated)
  //
  // These DO overlap with AllDms.js filter chips, but the dedicated pages
  // have action affordances the chip filter doesn't (per-row Release in
  // the release inbox; later: per-row Approve/Deny in the approvals
  // inbox once the manager action bar lands in Round 4). Both pages are
  // kept in sync with the chip filter — same backend endpoints, same
  // data shape, just a focused UI.
  //
  // The dms.release module gate (in EffectiveAccessService) already
  // resolves to: HasPerm("Documents Ready for Release") OR RoleId=8
  // (DMS Manager / Operations) OR RoleId=4 (IT Admin). No new perms
  // were added.
  { path: "/dms/my-training", component: (
      <RoleProtected requireModule="training.open">
        <MyTraining />
      </RoleProtected>
    ) },
  { path: "/dms/my-pending-approvals", component: (
      <RoleProtected requireModule="dms.myApprovals">
        <MyPendingApprovals />
      </RoleProtected>
    ) },
  {
    path: "/dms/awaiting-release",
    component: (
      <RoleProtected requireModule="dms.release">
        <AwaitingRelease />
      </RoleProtected>
    ),
  },
  // Round R12 (2026) — Drafts inbox + email-link action handler.
  // /dms/my-drafts: lists Status=60 docs authored by current user (Q11).
  // /dms/action/:token: lands the one-click approve/deny links from emails
  //   (replaces legacy /ApproveDMS/:token at sswhite.systems:8080).
  { path: "/dms/my-drafts", component: (
      <RoleProtected requireModule="dms.myDrafts">
        <MyDrafts />
      </RoleProtected>
    ) },
  { path: "/dms/action/:token", component: <TokenAction /> },

  { path: "/access-denied", component: <AccessDenied /> },

  //Display board
  // Phase 3: integrated apps are now gated behind RoleProtected so direct
  // URL access by an unauthenticated/unauthorized user redirects to
  // /access-denied. Backend authorization policies (CanAccessDigitalInspection,
  // CanAccessMafia, CanAccessDisplayBoard) also enforce 403 on the API.
  // The `requireModule` gate reads the bundle's modules map which is
  // resolved server-side from permissions + country + role — so future
  // restrictions only need a server change, no JS edits.
  {
    path: "/di",
    component: (
      <RoleProtected requireModule="app.di">
        <DI />
      </RoleProtected>
    ),
  },

  // Batch 3 / Round 15 — DI Simulator route (legacy Simselect / "-j"
  // engineer mode). Same app.di gate as /di; the screen itself is
  // read-only, so no write is possible from it.
  {
    path: "/di/simulator",
    component: (
      <RoleProtected requireModule="app.di">
        <DISimulator />
      </RoleProtected>
    ),
  },

  // Round DI-2 — DI Change Log (formerly "Audit Log"). PERMISSION-driven:
  // the "DI - Change Log" permission (gate di.changeLog) — grantable to the
  // quality-engineer role or specific people in Access Management; IT Admin
  // passes via the gate's fallback. The API (GET /Inspection/audit-log)
  // re-enforces the same permission and the job/PO scoping.
  {
    path: "/di/audit",
    component: (
      <RoleProtected requireModule="di.changeLog">
        <DIAuditLog />
      </RoleProtected>
    ),
  },

  {
    path: "/mafia",
    component: (
      <RoleProtected requireModule="app.mafia">
        <Mafia />
      </RoleProtected>
    ),
  },

  {
    path: "/display-boards",
    component: (
      <RoleProtected requireModule="app.displayboard">
        <DisplayBoards />
      </RoleProtected>
    ),
  },

  // Support module (Freshdesk). Visible to every authenticated user — the
  // "support" module gate (EffectiveAccessService.cs) is open because every
  // user can create and view THEIR OWN tickets. All-ticket vs requester-only
  // scope is enforced server-side in FreshdeskController from the
  // "Support Agent" perm / IT-Admin claim. Backend [Authorize] returns
  // 401/403 to anyone who bypasses this wrapper.
  {
    path: "/support",
    component: (
      <RoleProtected requireModule="support">
        <Support />
      </RoleProtected>
    ),
  },
  { path: "/review/exempted/:reviewId", component: <UnifiedReviewPage /> },

  { path: "/epo", component: (
      <RoleProtected requireModule="epo.create">
        <EPO />
      </RoleProtected>
    ) },
  { path: "/epo/:epoNumber/timeline", component: <EpoApprovalsTimeLine /> },

  // Phase 3 Pass 2 — additional EPO manager-menu screens.
  // Module keys (epo.mpc, epo.notReadyForPayment, epo.findByNumber)
  // are defined in EffectiveAccessService.cs. The bundle's modules
  // map is the source of truth — these RoleProtected wrappers just
  // ask the bundle "is this module visible for me?".
  {
    path: "/epo/mpc-viewer",
    component: (
      <RoleProtected requireModule="epo.mpc">
        <MpcEpoViewer />
      </RoleProtected>
    ),
  },
  // R30 — Accounting EPO Viewer. Same component, same data, different
  // title + gate. Mirrors legacy epoViewAllOfMy.vb (isAccounting
  // flag path).
  {
    path: "/epo/accounting-viewer",
    component: (
      <RoleProtected requireModule="epo.accounting">
        <MpcEpoViewer
          title="Accounting EPO Viewer"
          subtitle="Last 1000 EPOs across the company"
        />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/not-ready-for-payment",
    component: (
      <RoleProtected requireModule="epo.notReady">
        <EposNotReadyForPayment />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/find",
    component: (
      <RoleProtected requireModule="epo.findByNumber">
        <FindEpoByNumber />
      </RoleProtected>
    ),
  },
  // Batch 3 / Round 7 — line-item search (find an EPO by item description).
  {
    path: "/epo/find-by-item",
    component: (
      <RoleProtected requireModule="epo.lineSearch">
        <EpoLineSearch />
      </RoleProtected>
    ),
  },
  // Batch 3 / Round 8 — No-EPO / Missing-EPO shipment tracker.
  {
    path: "/epo/missing-epo",
    component: (
      <RoleProtected requireModule="epo.missingEpo">
        <MissingEpoDashboard />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/subordinates",
    component: (
      <RoleProtected requireManager>
        <SubordinateEpos />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/ready-for-payment",
    component: (
      <RoleProtected requireModule="epo.readyPay">
        <EposReadyForPayment />
      </RoleProtected>
    ),
  },
  {
    path: "/epo/shipping",
    component: (
      <RoleProtected requireModule="epo.receive">
        <EposShipping />
      </RoleProtected>
    ),
  },
  // R16 — receive details for a specific EPO (per-line receive/reopen actions).
  {
    path: "/epo/:epoNumber/receive",
    component: (
      <RoleProtected requireModule="epo.receive">
        <EposReceive />
      </RoleProtected>
    ),
  },
  // R19 — partial-payments per EPO (Finance/Babu/IT-Admin only).
  // isBabu already encompasses isFinance + isItAdmin in EffectiveAccessService,
  // so a single flag covers all three intended roles.
  {
    path: "/epo/:epoNumber/partial-payments",
    component: (
      <RoleProtected requireFlag="isBabu">
        <EpoPartialPayments />
      </RoleProtected>
    ),
  },
  { path: "/epo/awaiting-my-approval", component: (
      <RoleProtected requireModule="epo.myApprovals">
        <EpoApprovalsInbox />
      </RoleProtected>
    ) },

  // Phase 3 Pass 2 — Project Approval manager screens.
  {
    path: "/projects/my-department",
    component: (
      <RoleProtected requireModule="projects.deptProjects">
        <DeptProjects />
      </RoleProtected>
    ),
  },
  {
    path: "/projects/awaiting-approval",
    component: (
      <RoleProtected requireModule="projects.awaiting">
        <ProjectsAwaitingApproval />
      </RoleProtected>
    ),
  },

  // ─── Phase 3 Pass 3 — FTO/COA manager+HR + schedules ──────────────────
  // (existing /attendance/fto, /attendance/coa, etc. routes are untouched
  //  and continue to serve the unified Personal Attendance index page.)
  {
    path: "/attendance/dept/fto",
    // Batch 5 (G-18): added Manager + President + President-CEO to the
    // gate. Was hr.fto-only; legacy showed DeptFtos to managers too.
    // IT Admin bypass is automatic in RoleProtected.
    component: (<RoleProtected requireModule="attendance.deptFto"><DeptFtos /></RoleProtected>),
  },
  {
    path: "/attendance/dept/coa",
    // Batch 5 (G-18): same as DeptFtos — added Manager visibility.
    component: (<RoleProtected requireModule="attendance.deptCoa"><DeptCoas /></RoleProtected>),
  },
  {
    path: "/attendance/ytd",
    // Batch 5 (G-17): YTD FTO Status is no longer HR-only. Backend
    // /api/fto/ytd scopes the response (self / manager subtree / HR
    // dept-wide) so the FE gate just needs the user to be authenticated —
    // AuthProtected already enforces that one level up.
    component: (<RoleProtected requireModule="attendance.ytdFto"><YtdFtoReport /></RoleProtected>),
  },
  {
    // P8 / G-37: "My FTO Balance" — per-employee balance summary card.
    // Mirrors the legacy frmFtoViewYTD form. EmpID comes from JWT (the
    // page only ever shows the caller's own balances).
    path: "/attendance/my-balance",
    component: (<RoleProtected requireModule="attendance.myBalance"><MyFtoBalance /></RoleProtected>),
  },
  {
    // Batch 3 (G-15 FE): EmpReactivate page — HR/IT only. Mirrors the
    // legacy EmpReactivate.Designer.vb form. Backend was shipped in
    // Batch 7 (/api/registration/inactive-employees + /reactivate).
    path: "/hr/reactivate",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=employees&view=reactivate" replace /></RoleProtected>),
  },
  {
    // Go-live parity (2026-09-24): India accounts — dashboard accounts for the
    // people of Epicor company SN. HR / IT Admin; api/india-employees has the same gate.
    path: "/hr/india-employees",
    component: (<RoleProtected requireHr><IndiaEmployees /></RoleProtected>),
  },
  {
    // Phase 3 / Feature 2: HR landing dashboard — HR/IT only.
    path: "/hr/dashboard",
    component: (<RoleProtected requirePermission="HR Menu"><HrDashboard /></RoleProtected>),
  },
  {
    // Phase 3 / Feature 3: Employee self-service profile — any authenticated user.
    // AuthProtected at the Layout level already enforces sign-in.
    path: "/profile/me",
    component: (<MyProfile />),
  },
  {
    // Phase 3 / Feature 3: HR queue for profile-update approvals.
    path: "/hr/profile-approvals",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=review&view=profiles" replace /></RoleProtected>),
  },
  {
    // Phase 3 / Feature 4: HR Audit Trail.
    path: "/hr/audit",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=more&item=audit" replace /></RoleProtected>),
  },
  {
    // Batch P4: Year-End FTO admin (HR/IT only).
    // Frontend for the /api/fto/year-end/preview + /commit endpoints
    // shipped in Batch 5b.
    path: "/hr/fto-year-end",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=fto&item=year-end" replace /></RoleProtected>),
  },
  {
    // Batch P4: Add Paid FTO admin (HR/IT only).
    // Frontend for the /api/fto/consumed/add + list endpoints shipped
    // in Batch 5b.
    path: "/hr/paid-fto",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=fto&item=record-paid" replace /></RoleProtected>),
  },
  {
    // Phase 2 / G-31 — FTO HR Summary (per-emp snapshot grid).
    path: "/hr/fto-summary",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=fto&item=summary" replace /></RoleProtected>),
  },
  {
    // Phase 2 / G-32 — Compensation Days editor.
    path: "/hr/comp-days",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=fto&item=comp-days" replace /></RoleProtected>),
  },
  {
    // Phase 2 / G-33 — FTO Holiday editor.
    path: "/hr/holidays",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=fto&item=holidays" replace /></RoleProtected>),
  },
  {
    // Phase 2 / G-34 — Year-end request view (53-week per-emp audit).
    path: "/hr/year-end-request",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=fto&item=year-end-request" replace /></RoleProtected>),
  },
  {
    // HR Round 1 / Issue 2 — Unified HR Review Dashboard. One queue for all
    // pending FTO / COA / Profile / missing-punch items. Backend endpoint
    // (/api/dashboard/hr/review-queue) is CanAccessHR-gated, so direct URL
    // access without HR rights fails server-side too.
    path: "/hr/review",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=review" replace /></RoleProtected>),
  },
  {
    // HR Round 1 / Issue 3 — COA Central (COA counterpart to FTO Central).
    // Backend endpoint (/api/coa/central) is CanAccessHR-gated.
    path: "/hr/coa-central",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=coa" replace /></RoleProtected>),
  },
  {
    // HR Round 2 / Issue 6 — Late-In Review dashboard + email workflow.
    // Backend (/api/hr/late-in/*) is CanAccessHR-gated, so direct URL/API
    // access without HR rights fails server-side too.
    path: "/hr/late-in",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=review&view=latein" replace /></RoleProtected>),
  },
  {
    // HR Round 3 / Issue 5 — database-generated attendance report
    // (master-sheet grid + monthly counts). Backend CanAccessHR-gated.
    path: "/hr/attendance-report",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=reports&report=attendance" replace /></RoleProtected>),
  },
  {
    // HR Round 3 / Issue 5 — late-in summaries by employee/dept/supervisor.
    path: "/hr/late-in-report",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=review&view=latein&sub=summary" replace /></RoleProtected>),
  },
  {
    path: "/hr/attendance-analytics",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=reports&report=analytics" replace /></RoleProtected>),
  },
  {
    // Round 18 — payroll time card (legacy Time Card Report + automatic
    // paid/unpaid FTO, COA top-up, holiday credits). Backend CanAccessHR-gated.
    path: "/hr/payroll-timecard",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=reports&report=payroll" replace /></RoleProtected>),
  },
  {
    // Round 21 — HR enters a Paid OR Unpaid FTO for an employee (the direct
    // "give unpaid FTO" path). Backend CanAccessHR-gated (api/fto/hr-add).
    path: "/hr/add-fto",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=fto&item=add-fto" replace /></RoleProtected>),
  },
  {
    // Round 22 — combined FTO+COA history (approved/denied/pending) with HR
    // void. Backend CanAccessHR-gated (Reports/leave-archive + hr-void).
    path: "/hr/leave-archive",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=history" replace /></RoleProtected>),
  },
  {
    // Round 23 (simplification) — the HR command center: person search,
    // today strip, four task doors. Composes existing gated endpoints only.
    path: "/hr/home",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource" replace /></RoleProtected>),
  },
  {
    // Round 23 (simplification) — ONE wizard for paid/unpaid FTO, COA, and
    // payouts; routes to the existing hr-add / consumed endpoints.
    path: "/hr/record",
    component: (<RoleProtected requirePermission="HR Menu"><Navigate to="/humanresource?section=leave&area=record" replace /></RoleProtected>),
  },
  {
    path: "/attendance/fto/schedule",
    component: (<RoleProtected requireModule="attendance.myFtoSched"><FtoSchedule /></RoleProtected>),    // everyone sees their own
  },
  {
    path: "/attendance/coa/schedule",
    component: (<RoleProtected requireModule="attendance.myCoaSched"><CoaSchedule /></RoleProtected>),    // everyone sees their own
  },

  // ─── Phase 3 Pass 3 — Task Management manager screens ─────────────────
  {
    path: "/task-management/dept",
    component: (<RoleProtected requireModule="task.deptTasks"><DeptTasks /></RoleProtected>),
  },
  {
    path: "/task-management/by-date",
    component: (<RoleProtected requireModule="task.byDate"><TaskReportingByDate /></RoleProtected>),
  },
  {
    path: "/task-management/assigned",
    // Round 2: gated by task.assigned (true for everyone until
    // Access:Enforcement:TaskManagement is switched on).
    component: (<RoleProtected requireModule="task.assigned"><TasksIveAssigned /></RoleProtected>),
  },
  {
    // Round TM-7 (2026) — legacy Spot Check (direct reports only).
    path: "/task-management/activity",
    component: (<RoleProtected requireModule="task.deptTasks"><CurrentDeptActivity /></RoleProtected>),
  },
  {
    // Round TM-9 (2026) — every employee reviews their OWN day.
    path: "/task-management/eod",
    component: (<RoleProtected requireModule="tasks.open"><EndOfDay /></RoleProtected>),
  },
  {
    // Round TM-13 (2026) — Task Auditor permission (replaces legacy
    // hardcoded 2726/2706; IT Admin passes via the module map).
    path: "/task-management/auditor",
    component: (<RoleProtected requireModule="task.auditor"><TaskAuditor /></RoleProtected>),
  },

  // ─── Phase 3 Pass 3 — Travel Expense Approval ─────────────────────────
  {
    path: "/travel-expense",
    component: (<RoleProtected requireModule="travel.mine"><TravelExpenseIndex /></RoleProtected>),  // tabs adapt to manager status
  },
  // Create-new-request form (legacy frmTravelExpense.vb).
  // Must come BEFORE /travel-expense/:id so "new" isn't captured as an id.
  {
    path: "/travel-expense/new",
    component: (<RoleProtected requireModule="travel.new"><TravelExpenseForm /></RoleProtected>),
  },
  // Go-live parity (2026-09-24): HR "Awaiting Prepurchase" and Accounting
  // "Awaiting Reimbursement" / "Overdue" queues (legacy TEA back office).
  {
    path: "/travel-expense/hr-arrangements",
    component: (<RoleProtected requireModule="travel.hr"><TravelHrQueue /></RoleProtected>),
  },
  {
    path: "/travel-expense/accounting",
    component: (<RoleProtected requireModule="travel.accounting"><TravelAccountingQueue /></RoleProtected>),
  },
  // Go-live parity (2026-09-24): travel audit #25/#24 — the approval queue has
  // its own entry (a supervisor without "Travel - My Requests" can approve),
  // and the legacy MPC Request Viewer (all trips past Draft, "MPC EPO Viewer").
  {
    path: "/travel-expense/approvals",
    component: (<RoleProtected requireModule="travelExpense.approval"><TravelExpenseIndex key="approvals" initialTab="awaiting" /></RoleProtected>),
  },
  {
    path: "/travel-expense/all-requests",
    component: (<RoleProtected requireFlag="isMPC"><TravelExpenseIndex key="all-requests" initialTab="all" /></RoleProtected>),
  },
  {
    path: "/travel-expense/:id/edit",
    component: <TravelExpenseForm />,
  },
  {
    path: "/travel-expense/:id",
    component: <TravelExpenseDetail />,
  },

  // ─── Merged from development branch ────────────────────────────────────
  // Time & Attendance employee tools. Punch history & "Who's In Building"
  // are personal/department views — anyone authenticated can see them;
  // backend filters scope. Combined SchedulePage replaces splitting between
  // FtoSchedule and CoaSchedule (both keep working, this is the unified one).
  // Round 2 (audit §10): sub-routes now carry the same gate as the hub route.
  { path: "/time-and-attendance/punch-record", component: (<RoleProtected requireModule="time.open"><PunchRecord /></RoleProtected>) },
  { path: "/time-and-attendance/whos-in-building", component: (<RoleProtected requireModule="time.open"><WhosInBuilding /></RoleProtected>) },
  { path: "/attendance/schedule", component: <SchedulePage /> },

  // Expected Visitors register — front desk / receptionist use. Backend
  // (ExpectedVisitorsController) is currently [ApiController] without an
  // explicit policy; if you want to restrict this to receptionists only,
  // add a RoleProtected wrapper here and a policy on the controller.
  { path: "/visitors", component: (<RoleProtected requireModule="app.visitors"><ExpectedVisitors /></RoleProtected>) },

  // SN-PO Awaiting FL Approval — MPC/SuperUser/ItAdmin only. The page itself
  // also gates with useAuth().isMPC etc. so a direct URL hit shows a polite
  // "restricted" message instead of a blank page.
  { path: "/epo/sn-awaiting-fl-approval", component: (
      <RoleProtected requireModule="epo.snApprovals">
        <SnEpoAwaitingFlApproval />
      </RoleProtected>
    ) },

  // Contract Review (Pass 3 + Pass 4)
  { path: "/contract-review", component: (
      <RoleProtected requireModule="cr.open">
        <ContractReview />
      </RoleProtected>
    ) },
  // Round 2: creating a CR needs the module; /:id stays authenticated-only so
  // approvers reached through e-mail / pending-approvals links can open it.
  { path: "/contract-review/new", component: (<RoleProtected requireModule="cr.open"><ContractReviewForm /></RoleProtected>) },
  { path: "/contract-review/:id", component: <ContractReviewForm /> },
  { path: "/organizational-chart", component: (
      <RoleProtected requireModule="orgchart.open">
        <OrgChart />
      </RoleProtected>
    ) },
  // Round DMS-UAT-1 (2026) — Issue 1: the dashboard "Open Tasks" card links
  // here, but the page only ever shows the CALLER'S OWN tasks (the my-tasks
  // tabs). Gating a personal view behind "Task Management - Open" produced
  // the "Access Denied" the user reported while the card still showed their
  // task count. The tasks.open module gate was broader than required, so it
  // is removed from the personal index only. The manager screens below
  // (/task-management/dept, /task-management/by-date) keep their gates, and
  // the backend my-tasks endpoint now enforces caller identity server-side
  // (see TaskManagementController.GetMyTasks) — a direct URL or forged
  // ?empId= still cannot read anyone else's tasks.
  // Round 2 (decision Q-B): the Task Management base/create/view routes carry
  // the tasks.open key — true for every active employee until
  // Access:Enforcement:TaskManagement is switched on, then permission-based.
  { path: "/task-management", component: (<RoleProtected requireModule="tasks.open"><TaskManagement /></RoleProtected>) },
  {
    path: "/task-management/create",
    component: (<RoleProtected requireModule="tasks.open"><CreateTask /></RoleProtected>),
  },
  {
    path: "/task-management/view-task/:taskId",
    component: (<RoleProtected requireModule="tasks.open"><TaskDetail /></RoleProtected>),
  },

  //DI and //Mafia Routes
  // (Routes already declared above under "Display board" — second
  // declaration removed to prevent React Router duplicate-path warnings.)

  // Index — navbar points here
  { path: "/attendance", component: (
      <RoleProtected requireModule="attendance.mine">
        <AttendanceIndex />
      </RoleProtected>
    ) },

  // FTO form — new & edit
  { path: "/attendance/fto/new", component: (
      <RoleProtected requireModule="attendance.newFto">
        <FtoRequestPage />
      </RoleProtected>
    ) },
  // The ONE approvals screen (supervisor "My team" + HR queue) — the
  // notification bell links here. Any signed-in user: My team lists only their
  // direct reports; the HR view is API-gated (CanAccessHR). Must precede /:id.
  { path: "/attendance/approvals", component: <HrReviewDashboard initialScope="auto" /> },
  { path: "/attendance/fto/:id", component: <FtoRequestPage /> },

  // COA form — new & edit
  { path: "/attendance/coa/new", component: (
      <RoleProtected requireModule="attendance.newCoa">
        <FtoRequestPage />
      </RoleProtected>
    ) },
  { path: "/attendance/coa/:id", component: <FtoRequestPage /> },

  //DMS
  { path: "/document-management", component: (
      <RoleProtected requireModule="dms.all">
        <DocumentManagementSystem />
      </RoleProtected>
    ) },
  // Round 2: All Documents / Data carry the dms.all key like the hub card.
  { path: "/document-management/all-documents", component: (<RoleProtected requireModule="dms.all"><AllDocuments /></RoleProtected>) },
  { path: "/document-management/data", component: (<RoleProtected requireModule="dms.all"><Data /></RoleProtected>) },
  {
    // Round 2: "DMS - Create Documents" (dms.create — now a real module key).
    path: "/dms/create/:docType",
    component: (<RoleProtected requireModule="dms.create"><CreateEcn /></RoleProtected>),
  },
  {
    path: "/dms/edit/:docType/:id",
    component: <CreateEcn />,
  },
  // ✅ Email approval routes — no login required

  //Chat

  //EMail

  //Projects

  // Round TM-14 (2026) — audit L-7: the Velzon demo task routes
  // (/apps-tasks-list-view, /apps-tasks-details) are removed; they showed
  // template fake data at guessable URLs alongside the real module.

  //Api Key

  //Crm

  //Invoices

  //Supports Tickets

  //transactions

  // NFT Marketplace

  //charts


  // Base Ui

  // Advance Ui

  // Widgets

  // Forms

  //Tables

  //Icons

  //Maps

  //Pages

  //Job pages


  //User Profile
  // HR Round 5 / Issue 8 — profile unification. The Velzon template stub
  // (user-profile.js: hardcoded "Admin"/dummy data) is retired; every entry
  // point lands on the real self-service page. The /profile path is KEPT as
  // a redirect so old bookmarks/links keep working.
  { path: "/profile", component: <Navigate to="/profile/me" replace /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },

  //AuthenticationInner pages


  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  // Round 11: go-live password SETUP links (72 h) land here; same page, setup purpose.
  { path: "/set-password", component: <BasicPasswCreate /> },
  // Round 17: employees without e-mail — Emp ID + setup code from IT.
  { path: "/setup-code", component: <SetupCode /> },

  {
    path: "/ApproveDMS/:token",
    component: <ApprovalPage action="approve" />,
    isPublic: true, // remove this if you don't have a public route flag
  },
  {
    path: "/DenyDMS/:token",
    component: <ApprovalPage action="deny" />,
    isPublic: true,
  },
];

export { authProtectedRoutes, publicRoutes };
